import React, { useContext } from 'react';
const PullRefreshingContext = /*#__PURE__*/ React.createContext(false);
export const PullRefreshingProvider = PullRefreshingContext.Provider;
export const useIsPullRefreshing = ()=>useContext(PullRefreshingContext);
